import React from "react";
import RoutesWrapper from "./routes";
import useMultiNotification from "./hooks/useNotification";

function TwingeApp() {
  const { contextHolder } = useMultiNotification();
  return (
    <>
      {contextHolder}
      <RoutesWrapper />
    </>
  );
}

export default TwingeApp;
